// extracted by mini-css-extract-plugin
module.exports = {"container":"skillsList__container___1v_tH","title":"skillsList__title___2dv5D"};